<template>
<div>
    <loading v-if="loading"></loading>
    <template v-if="!loading">
        <div v-if="!invitee" class="form-group">
            <selectFriends :preload="true" @selected-friends="setUsers"></selectFriends>
        </div>
        <div class="form-group">
            <label>{{ t.album }}</label>
            <select class="form-control" v-model="album">
                <option v-for="album in albums" :key="album.id" :value="album.id">{{ album.name }}</option>
            </select>
        </div>
        <div class="form-group">
            <label>{{ t.invite_duration }}</label>
            <select class="form-control" v-model="expires">
                <option value="1">{{ t.day }}</option>
                <option value="7">{{ t.week }}</option>
                <option value="30">{{ t.month }}</option>
                <option value="365">{{ t.year }}</option>
                <option value="0">{{ t.permanent }}</option>
            </select>
        </div>
    </template>
</div>
</template>

<script>
import ajax from 'Site/js/util/ajax.fetch';
import SelectFriends from 'Site/component/SelectFriends.vue';
import Loading from 'Site/component/Loading.vue';
import { mapActions, mapState } from 'vuex';

export default {
    name: 'AlbumInvite',
    components: {
        SelectFriends,
        Loading
    },
    computed: mapState({
        currentUser: state => state.siteConfig.user
    }),
    data() {
        return {
            album: '',
            expires: '1',
            albums: [],
            loading: false,
            showFriendsModal: false,
            user: this.invitee,
            users: []
        };
    },
    methods: {
        ...mapActions(['notify']),
        error({ response }) {
            response.then((error) => {
                this.loading = false;
                this.$store.dispatch('notify', { msg: error.message, type: 'error' });
            });
        },
        load() {
            if (!this.albums.length) {
                if (!this.invitee) {
                    this.$parent.$emit('hideSubmit');
                }
                this.loading = true;
                ajax.get('album', { user: this.currentUser.id }).then((albums) => {
                    this.albums = albums.filter(album => album.private === true);
                    this.album = this.albums[0].id;
                    this.loading = false;
                });
            }
        },
        reset() {
            this.album = this.albums[0].id;
            this.expires = '1';
            if (!this.invitee) {
                this.$parent.$emit('hideSubmit');
            }
        },
        invite() {
            this.loading = true;
            if (this.users.length) {
                const promises = [];
                this.users.forEach((user) => {
                    this.user = user.userName;
                    promises.push(this.sendInvite());
                });
                Promise.all(promises).then(() => {
                    this.notify({ msg: this.t.invites_sent });
                    this.$parent.$emit('hideModal');
                    this.loading = false;
                    this.reset();
                }).catch(this.error);
            } else if (this.user) {
                this.sendInvite().then((response) => {
                    this.notify({ msg: response.message });
                    this.$parent.$emit('hideModal');
                    this.loading = false;
                    this.reset();
                }).catch(this.error);
            } else {
                this.loading = false;
            }
        },
        sendInvite() {
            return ajax.create('albumInvite', {
                identity: this.user,
                album: this.album,
                expires: this.expires
            });
        },
        setUsers(users) {
            if (users.length) {
                this.$parent.$emit('showSubmit');
            } else {
                this.$parent.$emit('hideSubmit');
            }
            this.users = users;
        }
    },
    mounted() {
        this.$on('show', this.load);
        this.$on('submit', this.invite);
    },
    props: {
        invitee: {
            type: Number
        },
        t: {
            type: Object,
            required: true
        }
    }
};

</script>
